var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSum2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E66100"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4219_60569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8432 25.2139C22.5086 24.7732 22.3218 24.2375 22.3099 23.6838L14.1343 22.521L12.0531 37.1322L20.2287 38.295L20.2291 38.2954C20.397 37.7689 20.724 37.3078 21.1644 36.9746C21.6067 36.643 22.142 36.4593 22.695 36.4501L24.1552 26.1495C23.6307 25.9832 23.1719 25.6558 22.8433 25.2139L22.8432 25.2139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0298 22.2322L28.3263 23.6574C28.2778 24.2065 28.0577 24.7268 27.6968 25.1437C27.3464 25.5768 26.8645 25.8838 26.3239 26.0183L27.1108 36.3887C27.6588 36.4421 28.1776 36.6619 28.5975 37.0181C29.0287 37.3739 29.3349 37.8577 29.4717 38.4L48.1497 36.9482L47.0298 22.2322ZM35.0067 25.9219C35.5213 25.8846 36.0074 26.1606 36.2394 26.6213C36.4715 27.082 36.4035 27.6369 36.0673 28.0277C35.731 28.4189 35.1923 28.5691 34.7024 28.4089C34.212 28.2487 33.8666 27.8091 33.8262 27.2949C33.7997 26.956 33.9096 26.6209 34.1313 26.3631C34.3527 26.1052 34.6678 25.9465 35.0067 25.922L35.0067 25.9219ZM39.7812 34.3251V34.3255C39.2678 34.3554 38.7864 34.0745 38.56 33.613C38.3337 33.1515 38.4063 32.5989 38.7445 32.2116C39.0826 31.8239 39.6198 31.6771 40.1082 31.8389C40.5962 32.001 40.9394 32.4399 40.979 32.9525C41.0082 33.2945 40.8967 33.6338 40.6712 33.8928C40.4452 34.1514 40.124 34.3074 39.7812 34.3254L39.7812 34.3251ZM34.0976 34.3251L33.4505 33.7306L40.3672 26.368L41.0143 26.9625L34.0976 34.3251Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4219_60569",
    x: 9.0531,
    y: 22.2322,
    width: 42.0966,
    height: 23.1677,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4219_60569"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4219_60569",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum2);
export default __webpack_public_path__ + "static/media/sum-2.18abbcc07c4f044fee2454f93dedf08c.svg";
export { ForwardRef as ReactComponent };